module.exports = __webpack_public_path__ + "img/DSC_2940-xs.59eee242.png";